import React from 'react';
import { CustomContainer } from './Layout.styled';

function SmallContainer(props) {
  return <CustomContainer className={props.className}>{props.children}</CustomContainer>;
}

export default SmallContainer;
